export interface SelectedModel {
    selected?: boolean;
}